import { Sun, Moon } from "lucide-react";
import { useClientTheme } from "@/contexts/ThemeContext";
import { useTranslation } from "react-i18next";

/* Compact icon-button used in the customer header. Click to flip between
 * light and dark. Tooltip hints that the current state was auto-detected
 * the first time. */
export default function ThemeSwitcher() {
  const { theme, setTheme } = useClientTheme();
  const { i18n } = useTranslation();
  const isEN = i18n.language === "en";
  const isLight = theme === "light";
  const next = isLight ? "dark" : "light";
  const label = isLight
    ? (isEN ? "Switch to dark" : "Passa al tema scuro")
    : (isEN ? "Switch to light" : "Passa al tema chiaro");
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      title={label}
      aria-label={label}
      data-testid="theme-switcher"
      className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-zinc-950/40 backdrop-blur-md border border-zinc-700/60 hover:border-[#FFD700]/70 hover:text-[#FFD700] text-zinc-100 transition-colors"
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
